export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14490.103ad8e7.jpg";